import React, { useEffect, useState } from "react";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import { ButtonStyleAzul, ButtonStyleVerde, CssTextField, DivBackgroundDasboard, MaxDiv, PaperStyle, TypographyStyleSecundary } from "../styles/Styles";
import { ListItemButton } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, Alert, Snackbar } from '@mui/material';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { AccountBalance } from "@mui/icons-material";
import Lottie from 'lottie-react-web'
import animationcheck from '../assets/checkmark.json';
import warning from '../assets/warning.json';


const SplashConfirmation = ({status}) => {

    let dataStatus = (status?.data?.estado === "ACEP" || status?.data?.estado === "Payment" || status?.estado === "AP") ? true : false;
    console.log("status===", dataStatus);
    console.log("state===", status)




    return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                width: '100vw',
                // backgroundColor: '#5d965c',
                backgroundColor: (dataStatus) ? '#5d965c' : '#ffffff',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
            }}>
                <Lottie
                    options={{
                        // animationData: animationcheck,
                        animationData: (dataStatus) ? animationcheck : warning,
                    }}
                    width={300}
                    height={300}
                />
            </div>

    )
}

export default SplashConfirmation;